import StorageService from "shared/services/StorageService";

export default async () => {
  // allow login in admin mode due to google auth not working on netlify domains
  if (window.location.origin.includes("netlify.app")) {
    const oldToken = localStorage.getItem("token");

    if (oldToken) {
      await StorageService.set("token", oldToken);
    }
  }
};
